module.exports = __webpack_public_path__ + "static/media/icon_visa.de836b39.svg";